import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

/** Sends anonymous visitors to sign-up, preserving where they were headed. */
const RequireAuth = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname);
    return <Navigate to={`/Signup?redirect=${redirect}`} replace />;
  }
  return <Outlet />;
};

export default RequireAuth;
